module.exports = __webpack_public_path__ + "static/media/default-profile-img.85d8d719.png";